import React from 'react'
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import user from '../../assets/img/user.png';
import './MiniAbout.css';
import { HiSpeakerWave } from "react-icons/hi2";
import sound from '../../assets/audio/obb.mp3'

const MiniAbout = () => {

    function play() {
        new Audio(sound).play()
    }


  return (

    <>
      <div className='mini-whole' id='statusquo'>
      <Card className='mini-whole' style={{border: 'none', textAlign: 'center'}}>
    <Card.Body className='mini-whole'>
    <img src={user} alt="" style={{height: '80px', width: '80px'}} />
      <br /> <br />
      <Card.Text className='miniabout-text'>
      I am a frontend developer with a strange obessession for developing <br /> and customizing websites, while simultaneously indulging in a <br /> coffee binge. I love the challenge of working in a competitive <br /> environment, constantly striving to  learn new things and deliver <br /> quality work  that benefits both sides of the table. <br />
      </Card.Text>
      
    </Card.Body>
  </Card>
 
      </div>
  

    </>
  )
}

export default MiniAbout